export const footerEventsConfig = {
    parentSelector: '.footer__inner', // Scope events to the main footer container
    events: {
        // Footer | click on logo (CSV Line 205)
        footerLogoClick: {
            selector: '.footer__logo a',
            event: {
                event: 'user_interaction',
                component: 'footer',
                element: 'logo',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href
                    };
                }
            }
        },

        // Footer | click on link (CSV Line 206)
        footerLinkClick: {
            // Target links within the main menu blocks and the bottom row
            selector: '.footer-block--menu a, .footer__column__bottom-links a',
            event: {
                event: 'user_interaction',
                component: 'footer',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Find the closest footer block or column
                    const block = element.closest('.footer-block.grid__item');
                    let blockHeading = 'General'; // Default if no specific heading found
                    if (block) {
                        const headingElement = block.querySelector('.footer-block__heading span');
                        if (headingElement) {
                            blockHeading = headingElement.textContent.trim();
                        }
                    } else if (element.closest('.footer__column__bottom-links')) {
                         blockHeading = 'Bottom Links'; // Specific category for bottom row links
                    }
                    
                    // Get link text, handling potential span inside
                    const linkSpan = element.querySelector('span');
                    const linkText = (linkSpan ? linkSpan.textContent.trim() : element.textContent.trim()) || 'Unknown Link';

                    return {
                        footer_block_heading: blockHeading, // As per CSV
                        link_text: linkText,
                        link_url: element.href
                    };
                }
            }
        },

        // Footer | click on social icon (CSV Line 207)
        footerSocialIconClick: {
            selector: '.list-social__item a',
            event: {
                event: 'user_interaction',
                component: 'footer',
                element: 'icon',
                sub_element: 'social', // Differentiate from other icons
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    let socialNetwork = 'Unknown';
                    const svg = element.querySelector('svg');
                    if (svg) {
                        const iconClass = svg.getAttribute('class') || '';
                        if (iconClass.includes('icon-facebook')) socialNetwork = 'Facebook';
                        else if (iconClass.includes('icon-instagram')) socialNetwork = 'Instagram';
                        // Add more checks if other social icons are added
                    }
                    return {
                        // social_network: socialNetwork, // Optional: Add if needed
                        link_url: element.href
                    };
                }
            }
        }
    }
}; 